import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { ActionProtalService } from '@features/referentiel/services/action-protal.service';
import { ActionPortalActions } from '@features/referentiel/actions/action-portal.actions';
import { AuthActions } from '@auth/store';
import { catchError, map, of, switchMap } from 'rxjs';

@Injectable()
export class ActionPortalEffects {

  initActions$ = createEffect(() =>
    this.actions$.pipe(
      ofType(AuthActions.userProfileLoaded),
      map(() => ActionPortalActions.getActionPortals()),
    ),
  );

  loadActions$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ActionPortalActions.getActionPortals),
      switchMap(() =>
        this.actionPortalService.getActionPortals().pipe(
          map((actionPortals) => ActionPortalActions.getActionPortalsSuccess({ actionPortals })),
          catchError((error) =>
            of(ActionPortalActions.getActionPortalsFailure({ errorMessage: error })),
          ),
        ),
      ),
    ),
  );

  constructor(private actions$: Actions, private actionPortalService: ActionProtalService) {}

}
